"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnBegin = exports.rulerContent = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-1cm73lq-0"
})(["display:flex;flex-direction:column;width:100%;background-color:#131823;"]);

exports.Wrapper = Wrapper;

var rulerContent = _styledComponents["default"].div.withConfig({
  displayName: "styles__rulerContent",
  componentId: "sc-1cm73lq-1"
})(["dislplay:flex;width:100%;"]);

exports.rulerContent = rulerContent;

var ColumnBegin = _styledComponents["default"].div.withConfig({
  displayName: "styles__ColumnBegin",
  componentId: "sc-1cm73lq-2"
})(["position:relative;color:#ffffff;width:3rem;left:-1.5rem;font-size:12px;"]);

exports.ColumnBegin = ColumnBegin;